/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccesoDenegado as AccesoDenegado,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_GestionNiveles as GestionNiveles,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_puedeRutaAdmin as puedeRutaAdmin,
} from "../../runtime/index.jsx";
export function NivelesJerarquicos() {
  let e = (0, ReactCompiler.c)(2);
  if (!puedeRutaAdmin(`/admin/niveles`)) {
    let t;
    return (
      e[0] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((t = <AccesoDenegado />), (e[0] = t))
        : (t = e[0]),
      t
    );
  }
  let t;
  return (
    e[1] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((t = (
          <EstructuraPrincipal
            title={`Niveles jerárquicos`}
            children={<GestionNiveles />}
          />
        )),
        (e[1] = t))
      : (t = e[1]),
    t
  );
}
